export default __webpack_public_path__ + "static/media/documentlogo.4a4c9348.png";